(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bf-card-heart"] && !Shopify.designMode) return;
  try {
    (function () {
    // Relocate each heart inside the card's gallery (image container) so it
    // overlays the image rather than the card body. The original block
    // location is a flex sibling of the gallery; positioning there put the
    // heart in the title/price area or off-screen.
    function relocateHearts() {
      document.querySelectorAll('.bf-cardx').forEach(function (cardx) {
        if (cardx._bfRelocated) return;
        var card = cardx.closest('product-card, .product-card');
        if (!card) return;
        var gallery = card.querySelector('slideshow-component') || card.querySelector('.product-media');
        if (!gallery) return;
        var heart = cardx.querySelector('[data-bf-cardx-heart]');
        if (heart) gallery.appendChild(heart);
        cardx._bfRelocated = true;
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', relocateHearts);
    } else {
      relocateHearts();
    }
    // Re-run on dynamic card additions (variant morph, infinite scroll)
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function () { relocateHearts(); });
      obs.observe(document.body, { childList: true, subtree: true });
    }

    // Wishlist persistence — local-only stub. Swappable with a real backend.
    function readWishlist() {
      try { return JSON.parse(localStorage.getItem('bf:wishlist') || '[]'); } catch (e) { return []; }
    }
    function writeWishlist(list) {
      try { localStorage.setItem('bf:wishlist', JSON.stringify(list)); } catch (e) {}
    }

    function syncHearts() {
      var saved = readWishlist();
      document.querySelectorAll('[data-bf-cardx-heart]').forEach(function (heart) {
        var handle = heart.getAttribute('data-handle');
        if (saved.indexOf(handle) > -1) heart.classList.add('is-saved');
        else heart.classList.remove('is-saved');
      });
    }

    document.addEventListener('click', function (event) {
      var heart = event.target.closest && event.target.closest('[data-bf-cardx-heart]');
      if (!heart) return;
      event.preventDefault();
      event.stopPropagation();
      var handle = heart.getAttribute('data-handle');
      var saved = readWishlist();
      var idx = saved.indexOf(handle);
      if (idx > -1) saved.splice(idx, 1);
      else saved.push(handle);
      writeWishlist(saved);
      syncHearts();
    });

    // Card hover image swap is intentionally OFF — the swatch hover behaviour
    // in bf-card-swatches.liquid now owns this interaction so we don't get
    // racing pointer handlers fighting over the card's <img>.

    // Initial sync
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncHearts);
    } else {
      syncHearts();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-card-swatches"] && !Shopify.designMode) return;
  try {
    // Preview a card swatch without changing navigation. Ramp colour pairs update
  // both rendered card slides so Horizon's independent hover state stays on the
  // same model and colour. Legacy finish swatches still update the lead image.
  (function () {
    var previewStates = new WeakMap();

    function getCard(dot) {
      return dot.closest('product-card') || dot.closest('.product-card');
    }

    function getCardImages(card) {
      if (!card) return [];
      var gallery = card.matches('[ref="cardGallery"]') ? card : card.querySelector('[ref="cardGallery"]');
      if (!gallery) return [];

      var images = [];
      gallery.querySelectorAll('slideshow-slide:not([hidden])').forEach(function (slide) {
        var image = slide.querySelector('.product-media__image');
        if (image && images.length < 2) images.push(image);
      });
      return images;
    }

    function imageState(image) {
      return {
        image: image,
        src: image.getAttribute('src'),
        srcset: image.getAttribute('srcset'),
        sizes: image.getAttribute('sizes')
      };
    }

    function restoreAttribute(element, name, value) {
      if (value === null) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value);
      }
    }

    function setImageSource(image, source) {
      if (!image || !source) return;
      image.removeAttribute('srcset');
      image.setAttribute('src', source);
    }

    function applyCardMedia(card, dot, remember) {
      if (!card || !dot) return;
      var primary = dot.getAttribute('data-swap-src');
      var hover = dot.getAttribute('data-swap-hover-src');
      if (!primary && !hover) return;

      var images = getCardImages(card);
      if (!images.length) return;

      if (remember && !previewStates.has(card)) {
        previewStates.set(card, {
          images: images.map(imageState),
          featuredMediaUrl: card.getAttribute('data-featured-media-url')
        });
      }

      setImageSource(images[0], primary);
      if (hover && images[1]) setImageSource(images[1], hover);
      if (primary && card.hasAttribute('data-featured-media-url')) {
        card.setAttribute('data-featured-media-url', primary);
      }
    }

    function restoreCardMedia(card) {
      var state = previewStates.get(card);
      if (!state) return;

      state.images.forEach(function (saved) {
        restoreAttribute(saved.image, 'src', saved.src);
        restoreAttribute(saved.image, 'srcset', saved.srcset);
        restoreAttribute(saved.image, 'sizes', saved.sizes);
      });
      restoreAttribute(card, 'data-featured-media-url', state.featuredMediaUrl);
      previewStates.delete(card);
    }

    function applyCurrentCardSwatches(root) {
      var currentDots = [];
      var scope = root && root.querySelectorAll ? root : document;
      if (
        root &&
        root.matches &&
        root.matches('.bf-cardsw .is-current[data-swap-hover-src]')
      ) {
        currentDots.push(root);
      }
      scope.querySelectorAll('.bf-cardsw .is-current[data-swap-hover-src]').forEach(function (dot) {
        currentDots.push(dot);
      });

      currentDots.forEach(function (dot) {
        if (dot.dataset.bfCardMediaApplied === 'true') return;
        var card = getCard(dot);
        if (!card) return;
        applyCardMedia(card, dot, false);
        dot.dataset.bfCardMediaApplied = 'true';
      });
    }

    function syncSelectedFilterCard(card, basePath, selectedHref, selectedHandle) {
      if (!card || !card.isConnected) return;

      card.querySelectorAll('a[href]').forEach(function (link) {
        if (link.closest('[data-bf-cardsw]')) return;
        var linkPath = new URL(link.href, window.location.origin).pathname;
        var isCardTarget = link.matches(
          '.product-card__link, [ref="productCardLink"], [ref="productTitleLink"], [ref="cardGalleryLink"]'
        );
        if ((isCardTarget || linkPath == basePath) && link.href != selectedHref) {
          link.href = selectedHref;
        }
      });

      var cardx = card.querySelector('[data-bf-cardx]');
      var heart = card.querySelector('[data-bf-cardx-heart]');
      if (selectedHandle && cardx) cardx.setAttribute('data-handle', selectedHandle);
      if (selectedHandle && heart) {
        heart.setAttribute('data-handle', selectedHandle);
        try {
          var saved = JSON.parse(localStorage.getItem('bf:wishlist') || '[]');
          heart.classList.toggle('is-saved', saved.indexOf(selectedHandle) > -1);
        } catch (error) {}
      }
    }

    function applySelectedFilterSwatches(root) {
      var selectedDots = [];
      var scope = root && root.querySelectorAll ? root : document;
      if (root && root.matches && root.matches('[data-bf-filter-selected="true"]')) {
        selectedDots.push(root);
      }
      scope.querySelectorAll('[data-bf-filter-selected="true"]').forEach(function (dot) {
        selectedDots.push(dot);
      });

      selectedDots.forEach(function (dot) {
        if (dot.dataset.bfFilterApplied === 'true') return;
        var swatches = dot.closest('[data-bf-cardsw]');
        var card = getCard(dot);
        if (!swatches || !card) return;

        applyCardMedia(card, dot, false);

        var baseUrl = swatches.getAttribute('data-bf-product-base-url');
        var selectedUrl = dot.getAttribute('href');
        if (!baseUrl || !selectedUrl) return;

        var basePath = new URL(baseUrl, window.location.origin).pathname;
        var selectedHref = new URL(selectedUrl, window.location.origin).href;
        var selectedPath = new URL(selectedHref).pathname.split('/').filter(Boolean);
        var selectedHandle = selectedPath[selectedPath.length - 1];
        syncSelectedFilterCard(card, basePath, selectedHref, selectedHandle);
        if (window.customElements && window.customElements.whenDefined) {
          window.customElements.whenDefined('product-card').then(function () {
            syncSelectedFilterCard(card, basePath, selectedHref, selectedHandle);
          });
        }
        dot.dataset.bfFilterApplied = 'true';
      });
    }

    function hydrateCardSwatches(root) {
      applyCurrentCardSwatches(root);
      applySelectedFilterSwatches(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrateCardSwatches);
    } else {
      hydrateCardSwatches();
    }
    if ('MutationObserver' in window) {
      var filterSwatchObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) hydrateCardSwatches(node);
          });
        });
      });
      filterSwatchObserver.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('pointerover', function (event) {
      var dot = event.target.closest && event.target.closest('[data-bf-swatch]');
      if (!dot) return;
      if (event.relatedTarget && dot.contains(event.relatedTarget)) return;
      var card = getCard(dot);
      if (!card) return;
      applyCardMedia(card, dot, true);
    });
    document.addEventListener('pointerout', function (event) {
      var dot = event.target.closest && event.target.closest('[data-bf-swatch]');
      if (!dot) return;
      if (event.relatedTarget && dot.contains(event.relatedTarget)) return;
      var card = getCard(dot);
      if (!card) return;
      restoreCardMedia(card);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-draincap-upsell"] && !Shopify.designMode) return;
  try {
    (function() {
  var container = document.querySelector('.bf-draincap');
  if (!container) return;

  var label = container.querySelector('.bf-draincap__selected');

  container.addEventListener('click', function(e) {
    var btn = e.target.closest('.bf-draincap__swatch');
    if (!btn) return;

    var siblings = container.querySelectorAll('.bf-draincap__swatch');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('bf-draincap__swatch--active');
    }
    btn.classList.add('bf-draincap__swatch--active');

    if (label) {
      label.textContent = btn.dataset.variantTitle.toUpperCase();
    }

    var variantId = btn.dataset.variantId;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items: [{id: parseInt(variantId), quantity: 1}]})
    }).then(function() {
      window.location.href = '/cart';
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-feature-badges"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bfBadgesInit) return;
    window.__bfBadgesInit = true;

    function openModal(container, data, trigger) {
      var modal = container.querySelector('[data-bf-badge-modal]');
      if (!modal) return;
      var img = modal.querySelector('[data-bf-badge-modal-img]');
      var video = modal.querySelector('[data-bf-badge-modal-video]');
      var title = modal.querySelector('[data-bf-badge-modal-title]');
      var text = modal.querySelector('[data-bf-badge-modal-text]');
      /* Badeloft 2026-08-30: a badge can carry a looping video instead of a still. */
      if (video) {
        if (data.video) {
          if (video.getAttribute('src') !== data.video) video.src = data.video;
          video.hidden = false;
          var vp = video.play();
          if (vp && vp.catch) vp.catch(function () {});
        } else {
          video.pause();
          video.removeAttribute('src');
          video.load();
          video.hidden = true;
        }
      }
      if (img) {
        if (data.img && !data.video) {
          img.src = data.img;
          img.alt = data.title || '';
          img.hidden = false;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }
      }
      if (title) title.textContent = data.title || '';
      if (text) {
        text.textContent = data.text || '';
        text.style.display = data.text ? '' : 'none';
      }
      modal.__bfTrigger = trigger;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeButton = modal.querySelector('button[data-bf-badge-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
    }

    function closeModal(modal) {
      var cv = modal.querySelector('[data-bf-badge-modal-video]');
      if (cv) { cv.pause(); try { cv.currentTime = 0; } catch (e) {} }
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (modal.__bfTrigger) modal.__bfTrigger.focus({ preventScroll: true });
    }

    function trapFocus(modal, event) {
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) { return !element.hidden && element.offsetParent !== null; });
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bf-badge]');
      if (trigger) {
        var container = trigger.closest('.bf-badges');
        if (container) openModal(container, {
          img: trigger.getAttribute('data-bf-badge-img'),
          video: trigger.getAttribute('data-bf-badge-video'),
          title: trigger.getAttribute('data-bf-badge-title'),
          text: trigger.getAttribute('data-bf-badge-text')
        }, trigger);
        return;
      }

      var closer = event.target.closest('[data-bf-badge-close]');
      if (closer) {
        var modal = closer.closest('[data-bf-badge-modal]');
        if (modal) closeModal(modal);
      }
    });

    document.addEventListener('keydown', function (event) {
      var activeModal = document.querySelector('[data-bf-badge-modal]:not([hidden])');
      if (!activeModal) return;
      if (event.key === 'Tab') {
        trapFocus(activeModal, event);
      } else if (event.key === 'Escape') {
        closeModal(activeModal);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-finish-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    // Mirror the checked option value into the legend ("Finish : GLOSSY WHITE").
    // Idempotent: only writes when the value actually differs, so it is safe to
    // run from a MutationObserver without looping.
    function syncOne(fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var checked = fs.querySelector('input:checked');
      var val = checked ? checked.value : '';
      var sel = legend.querySelector('.bf-fsw__sel');
      if (!sel) {
        sel = document.createElement('span');
        sel.className = 'bf-fsw__sel';
        legend.appendChild(document.createTextNode(' : '));
        legend.appendChild(sel);
      }
      if (sel.textContent !== val) sel.textContent = val;
    }

    function syncRoot(root) {
      root.querySelectorAll('.variant-option--buttons').forEach(syncOne);
    }

    function init() {
      document.querySelectorAll('.bf-finish-swatches').forEach(function (root) {
        if (root.dataset.bfFswBound) return;
        root.dataset.bfFswBound = '1';
        syncRoot(root);
        // Horizon morphs the section on variant change, re-rendering the
        // legend from scratch — re-sync whenever the subtree changes.
        new MutationObserver(function () { syncRoot(root); })
          .observe(root, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Instant feedback on click, before Horizon's section morph lands
    document.addEventListener('change', function (e) {
      var root = e.target.closest && e.target.closest('.bf-finish-swatches');
      if (root) syncRoot(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    // The drawer is captured into the header section and ends up inside
    // header__columns, which Horizon transitions with opacity:0 / translateY
    // on load. Move the drawer to <body> so it sits at the page root and
    // escapes those inherited animations. position:fixed handles layout.
    function relocateDrawer() {
      var drawer = document.querySelector('[data-bf-mm-drawer]');
      if (!drawer) return;
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    }

    function syncIpadMenuMode() {
      var ua = navigator.userAgent || '';
      var platform = navigator.platform || '';
      var isIpad = /iPad/.test(ua) || (platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1);
      document.documentElement.classList.toggle('bf-ipados-menu-drawer', isIpad);
    }

    syncIpadMenuMode();
    window.addEventListener('resize', syncIpadMenuMode);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncIpadMenuMode);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        syncIpadMenuMode();
        relocateDrawer();
      });
    } else {
      relocateDrawer();
    }

    function lockScroll(lock) {
      var html = document.documentElement;
      var body = document.body;
      if (lock) {
        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
      } else {
        html.style.overflow = '';
        body.style.overflow = '';
      }
    }

    function setDesktopMenuOpen(item, open) {
      if (!item) return;
      var trigger = item.querySelector('[data-bf-mm-trigger]');
      item.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeOtherDesktopMenus(currentItem) {
      document.querySelectorAll('.bf-mm__item--dropdown-only.is-open').forEach(function (item) {
        if (item === currentItem) return;
        delete item.dataset.bfMmPinned;
        setDesktopMenuOpen(item, false);
      });
    }

    document.querySelectorAll('[data-bf-mm-trigger]').forEach(function (btn) {
      if (btn._bfMmDesktopReady) return; btn._bfMmDesktopReady = true;
      var item = btn.closest('.bf-mm__item--dropdown-only');
      if (!item) return;

      item.addEventListener('mouseenter', function () {
        closeOtherDesktopMenus(item);
        setDesktopMenuOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        if (item.dataset.bfMmPinned === 'true') return;
        setDesktopMenuOpen(item, false);
      });
      item.addEventListener('focusout', function (event) {
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        delete item.dataset.bfMmPinned;
        setDesktopMenuOpen(item, false);
      });
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var isPinned = item.dataset.bfMmPinned === 'true';
        closeOtherDesktopMenus(item);
        if (isPinned) {
          delete item.dataset.bfMmPinned;
          setDesktopMenuOpen(item, false);
        } else {
          item.dataset.bfMmPinned = 'true';
          setDesktopMenuOpen(item, true);
        }
      });
    });

    document.addEventListener('click', function (event) {
      document.querySelectorAll('.bf-mm__item--dropdown-only.is-open').forEach(function (item) {
        if (item.contains(event.target)) return;
        delete item.dataset.bfMmPinned;
        setDesktopMenuOpen(item, false);
      });
    });

    document.querySelectorAll('[data-bf-mm-open]').forEach(function (btn) {
      if (btn._bfMmReady) return; btn._bfMmReady = true;
      btn.addEventListener('click', function () {
        var drawer = document.querySelector('[data-bf-mm-drawer]');
        if (!drawer) return;
        drawer.hidden = false;
        // Force a reflow so the initial closed-state styles are committed,
        // then add .is-open on the next tick. Without this the element goes
        // from display:none straight to is-open and the transition freezes.
        // eslint-disable-next-line no-unused-expressions
        drawer.offsetHeight;
        setTimeout(function () { drawer.classList.add('is-open'); }, 16);
        btn.setAttribute('aria-expanded', 'true');
        lockScroll(true);
      });
    });
    document.addEventListener('click', function (event) {
      var closer = event.target.closest && event.target.closest('[data-bf-mm-close]');
      if (!closer) return;
      var drawer = closer.closest('[data-bf-mm-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      var opener = document.querySelector('[data-bf-mm-open]');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      setTimeout(function () { drawer.hidden = true; }, 320);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var desktopTrigger = document.querySelector('[data-bf-mm-trigger][aria-expanded="true"]');
      if (desktopTrigger) {
        var desktopItem = desktopTrigger.closest('.bf-mm__item--dropdown-only');
        delete desktopItem.dataset.bfMmPinned;
        setDesktopMenuOpen(desktopItem, false);
        desktopTrigger.focus();
        event.preventDefault();
      }
      var drawer = document.querySelector('[data-bf-mm-drawer].is-open');
      if (drawer) {
        var closer = drawer.querySelector('[data-bf-mm-close]');
        if (closer) closer.click();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-product-addons"] && !Shopify.designMode) return;
  try {
    (function() {
  var addons = document.querySelector('.bf-addons');
  if (!addons) return;

  var addonPrices = { 'drain-cap': 0, 'ezdrop': 0 };
  var addonSelections = {};

  function updateDisplayedPrice() {
    /* Find the price element inside the product details section (not recommendation cards) */
    var productSection = addons.closest('section') || addons.closest('[class*="product"]') || document;
    var priceEl = productSection.querySelector('.price__regular:not(.price__hidden) .price');
    if (!priceEl) priceEl = productSection.querySelector('span.price');
    if (!priceEl) return;

    var baseText = priceEl.getAttribute('data-base-price');
    if (!baseText) {
      priceEl.setAttribute('data-base-price', priceEl.textContent.trim());
      baseText = priceEl.textContent.trim();
    }

    var base = parseFloat(baseText.replace(/[^0-9.]/g, '')) * 100;
    var total = base + addonPrices['drain-cap'] + addonPrices['ezdrop'];
    var formatted = '$' + (total / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    priceEl.textContent = formatted;
  }

  /* Drain cap clicks */
  addons.addEventListener('click', function(e) {
    var swatch = e.target.closest('.bf-addons__swatch');
    if (!swatch) return;
    e.preventDefault();

    var group = swatch.closest('.bf-addons__group');
    var siblings = group.querySelectorAll('.bf-addons__swatch');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('is-active');
    }
    swatch.classList.add('is-active');

    var label = group.querySelector('.bf-addons__cap-name');
    if (label) label.textContent = swatch.dataset.variantTitle;

    var price = parseInt(swatch.dataset.addonPrice || '0');
    addonPrices['drain-cap'] = price;

    if (price > 0) {
      addonSelections['drain-cap'] = { id: parseInt(swatch.dataset.variantId), quantity: 1 };
    } else {
      delete addonSelections['drain-cap'];
    }

    updateDisplayedPrice();
  });

  /* EZ-Drop toggle */
  addons.addEventListener('change', function(e) {
    var cb = e.target.closest('.bf-addons__checkbox');
    if (!cb) return;

    if (cb.checked) {
      addonPrices['ezdrop'] = parseInt(cb.dataset.addonPrice || '0');
      addonSelections['ezdrop'] = { id: parseInt(cb.dataset.variantId), quantity: 1 };
    } else {
      addonPrices['ezdrop'] = 0;
      delete addonSelections['ezdrop'];
    }
    updateDisplayedPrice();
  });

  /* Intercept Add to Cart */
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(e) {
      var items = Object.values(addonSelections);
      if (items.length === 0) return;

      e.preventDefault();

      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var mainId = variantInput ? parseInt(variantInput.value) : null;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (!mainId) return;

      var allItems = [{ id: mainId, quantity: qty }];
      items.forEach(function(addon) { allItems.push(addon); });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: allItems })
      }).then(function(res) {
        if (res.ok) window.location.href = '/cart';
      });
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-product-options"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('.bf-cfg');
    if (!root) return;

    /* ---- Finish: keep the row-header value in sync (instant, pre-morph) ---- */
    function syncFinishValue() {
      var checked = root.querySelector('.variant-option__button-label input:checked');
      var valueEl = root.querySelector('[data-bf-finish-value]');
      if (checked && valueEl && valueEl.textContent !== checked.value) {
        valueEl.textContent = checked.value;
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('.variant-option__button-label')) syncFinishValue();
    });

    /* ---- EZ-Drop "how it works" video popup ---- */
    var videoModal = document.querySelector('[data-bf-videomodal]');
    if (videoModal) {
      var videoEmbed = videoModal.querySelector('[data-bf-videoembed]');
      var openVideo = function (id) {
        videoEmbed.innerHTML = '<iframe src="https://www.youtube.com/embed/' + encodeURIComponent(id) +
          '?autoplay=1&rel=0&modestbranding=1" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>';
        videoModal.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      var closeVideo = function () {
        videoModal.hidden = true;
        videoEmbed.innerHTML = '';
        document.body.style.overflow = '';
      };
      root.addEventListener('click', function (e) {
        var trigger = e.target.closest('.bf-cfg__videolink');
        if (trigger) { e.preventDefault(); openVideo(trigger.dataset.bfVideo); }
      });
      videoModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-bf-videoclose]')) closeVideo();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !videoModal.hidden) closeVideo();
      });
    }

    /* ---- Add-on price + selection state ---- */
    var addonPrices = { 'drain-cap': 0, 'ezdrop': 0 };
    var addonSelections = {};

    function updateAcceleratedCheckoutAvailability() {
      var productSection = root.closest('[id^="shopify-section-"]') || document;
      var acceleratedCheckout = productSection.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (!acceleratedCheckout) return;

      var hasAddon = Object.keys(addonSelections).length > 0;
      if (hasAddon) {
        acceleratedCheckout.hidden = true;
        acceleratedCheckout.dataset.badeloftAddonHidden = 'true';
        acceleratedCheckout.setAttribute('aria-hidden', 'true');
      } else if (acceleratedCheckout.dataset.badeloftAddonHidden === 'true') {
        var addButton = productSection.querySelector('form.shopify-product-form button[name="add"]');
        acceleratedCheckout.hidden = Boolean(addButton && addButton.disabled);
        delete acceleratedCheckout.dataset.badeloftAddonHidden;
        acceleratedCheckout.removeAttribute('aria-hidden');
      }
    }

    var configuratorSection = root.closest('[id^="shopify-section-"]');
    if (configuratorSection) {
      configuratorSection.addEventListener('variant:update', function () {
        window.setTimeout(updateAcceleratedCheckoutAvailability, 0);
      });
    }

    function updateDisplayedPrice() {
      updateAcceleratedCheckoutAvailability();
      /* Scope to the product info column — there is exactly one visible
         span.price there. Scanning the whole document grabbed a related-
         product card price instead. */
      var productCol = root.closest('.product-details') || root.closest('section') || document;
      var priceEl = productCol.querySelector('.price__regular:not(.price__hidden) .price')
                 || productCol.querySelector('span.price');
      if (!priceEl) return;
      var baseText = priceEl.getAttribute('data-base-price');
      if (!baseText) {
        baseText = priceEl.textContent.trim();
        priceEl.setAttribute('data-base-price', baseText);
      }
      var base = parseFloat(baseText.replace(/[^0-9.]/g, '')) * 100;
      var total = base + addonPrices['drain-cap'] + addonPrices['ezdrop'];
      priceEl.textContent = '$' + (total / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    /* Drain cap tile selection */
    root.addEventListener('click', function (e) {
      var tile = e.target.closest('.bf-cfg__cap');
      if (!tile) return;
      e.preventDefault();
      var group = tile.closest('[data-addon="drain-cap"]');
      group.querySelectorAll('.bf-cfg__cap').forEach(function (t) { t.classList.remove('is-active'); });
      tile.classList.add('is-active');
      var valueEl = group.querySelector('[data-bf-cap-value]');
      if (valueEl) valueEl.textContent = tile.dataset.variantTitle;
      var price = parseInt(tile.dataset.addonPrice || '0', 10);
      addonPrices['drain-cap'] = price;
      if (price > 0) {
        addonSelections['drain-cap'] = { id: parseInt(tile.dataset.variantId, 10), quantity: 1 };
      } else {
        delete addonSelections['drain-cap'];
      }
      updateDisplayedPrice();
    });

    /* EZ-Drop toggle */
    root.addEventListener('change', function (e) {
      var cb = e.target.closest('.bf-cfg__checkbox');
      if (!cb) return;
      if (cb.checked) {
        addonPrices['ezdrop'] = parseInt(cb.dataset.addonPrice || '0', 10);
        addonSelections['ezdrop'] = { id: parseInt(cb.dataset.variantId, 10), quantity: 1 };
      } else {
        addonPrices['ezdrop'] = 0;
        delete addonSelections['ezdrop'];
      }
      updateDisplayedPrice();
    });

    /* Bundle add-ons through Horizon's delegated product-form handler. The
       first /cart/add form is the Shop Pay instalment form, and Horizon handles
       submit events at document capture, before a form listener can intervene. */
    function bindBundleHandler() {
      var productSection = root.closest('[id^="shopify-section-"]') || document;
      var form = Array.prototype.find.call(
        productSection.querySelectorAll('form.shopify-product-form[action*="/cart/add"]'),
        function (candidate) {
          return candidate.querySelector('button[name="add"]')
            && candidate.querySelector('input[name="id"], select[name="id"]');
        }
      );
      var productForm = form ? form.closest('product-form-component') : null;
      if (
        !form
        || !productForm
        || typeof productForm.handleSubmit !== 'function'
        || productForm.dataset.badeloftBundleHandlerBound === 'true'
      ) return;

      var nativeHandleSubmit = productForm.handleSubmit;
      productForm.handleSubmit = function (e) {
        var items = Object.keys(addonSelections).map(function (k) { return addonSelections[k]; });
        if (items.length === 0) return nativeHandleSubmit.call(this, e);

        var quantitySelector = this.refs && this.refs.quantitySelector;
        if (quantitySelector && typeof quantitySelector.canAddToCart === 'function') {
          var validation = quantitySelector.canAddToCart();
          if (!validation.canAdd) return nativeHandleSubmit.call(this, e);
        }

        var variantInput = form.querySelector('input[name="id"], select[name="id"]');
        var intendedVariantId = new URL(window.location.href).searchParams.get('variant')
          || (variantInput ? variantInput.value : null);
        var mainId = intendedVariantId ? parseInt(intendedVariantId, 10) : null;
        if (!mainId) return nativeHandleSubmit.call(this, e);

        var qtyInput = form.querySelector('input[name="quantity"]');
        var qty = quantitySelector && typeof quantitySelector.getValue === 'function'
          ? Number(quantitySelector.getValue())
          : (qtyInput ? Number(qtyInput.value) : Number(this.dataset.quantityDefault));
        qty = qty || 1;

        e.preventDefault();
        if (this.dataset.badeloftBundleSubmitting === 'true') return;

        var addButtonContainer = this.refs && this.refs.addToCartButtonContainer;
        var addButton = form.querySelector('button[name="add"]');
        if (addButton && addButton.disabled) return;

        this.dataset.badeloftBundleSubmitting = 'true';
        if (addButtonContainer && typeof addButtonContainer.disable === 'function') {
          addButtonContainer.disable();
        } else if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
        }

        var activeProductForm = this;
        var perUnitAddons = items.map(function (item) {
          return { id: item.id, quantity: qty };
        });
        var allItems = [{ id: mainId, quantity: qty }].concat(perUnitAddons);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: allItems })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (data) {
              throw new Error(data.description || data.message || ('Cart bundle request failed with status ' + res.status));
            });
          }
          return res.json();
        }).then(function () {
          window.location.href = '/cart';
        }).catch(function (error) {
          var publicMessage = 'We could not add all selected items. Please try again.';
          var errorText = activeProductForm.refs && activeProductForm.refs.addToCartTextError;
          var liveRegion = activeProductForm.refs && activeProductForm.refs.liveRegion;

          delete activeProductForm.dataset.badeloftBundleSubmitting;
          if (addButtonContainer && typeof addButtonContainer.enable === 'function') {
            addButtonContainer.enable();
          } else if (addButton) {
            addButton.disabled = false;
            addButton.removeAttribute('aria-disabled');
          }

          if (errorText) {
            var messageNode = errorText.querySelector('[data-badeloft-bundle-error]');
            if (!messageNode) {
              messageNode = document.createElement('span');
              messageNode.setAttribute('data-badeloft-bundle-error', '');
              errorText.appendChild(messageNode);
            }
            messageNode.textContent = publicMessage;
            errorText.classList.remove('hidden');
            errorText.setAttribute('aria-live', 'assertive');
          }
          if (liveRegion) liveRegion.textContent = publicMessage;
          console.error('[Badeloft add-ons] Unable to add the selected bundle.', error);
        });
      };
      productForm.dataset.badeloftBundleHandlerBound = 'true';
    }

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('product-form-component').then(bindBundleHandler);
    } else {
      bindBundleHandler();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bf-send-to-designer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bfStdInit) return;
    window.__bfStdInit = true;

    function lock(v) { document.documentElement.style.overflow = v ? 'hidden' : ''; }

    function trapFocus(modal, event) {
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) { return !element.hidden && element.offsetParent !== null; });
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-bf-std-open]');
      if (open) {
        var modal = open.parentElement.querySelector('[data-bf-std-modal]');
        if (modal) {
          modal.__bfTrigger = open;
          modal.hidden = false;
          lock(true);
          var closeButton = modal.querySelector('button[data-bf-std-close]');
          if (closeButton) closeButton.focus({ preventScroll: true });
        }
        return;
      }
      var close = e.target.closest('[data-bf-std-close]');
      if (close) {
        var m = close.closest('[data-bf-std-modal]');
        if (m) {
          m.hidden = true;
          lock(false);
          if (m.__bfTrigger) m.__bfTrigger.focus({ preventScroll: true });
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      var activeModal = document.querySelector('[data-bf-std-modal]:not([hidden])');
      if (!activeModal) return;
      if (e.key === 'Tab') {
        trapFocus(activeModal, e);
      } else if (e.key === 'Escape') {
        activeModal.hidden = true;
        lock(false);
        if (activeModal.__bfTrigger) activeModal.__bfTrigger.focus({ preventScroll: true });
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.bf-std__form');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.bf-std__submit');
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      var dialog = form.closest('.bf-std__dialog');
      var wrap = dialog && dialog.querySelector('[data-bf-std-formwrap]');
      var ok = dialog && dialog.querySelector('[data-bf-std-success]');
      var error = dialog && dialog.querySelector('[data-bf-std-error]');
      if (error) error.hidden = true;
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      }
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Contact form request failed');
          return response.text();
        })
        .then(function (html) {
          var result = new DOMParser().parseFromString(html, 'text/html');
          var formModal = form.closest('[data-bf-std-modal]');
          var successId = formModal && formModal.id ? formModal.id + '-posted' : '';
          if (!successId || !result.getElementById(successId)) {
            throw new Error('Contact form was not accepted');
          }
          if (btn) btn.removeAttribute('aria-busy');
          if (wrap) wrap.hidden = true;
          if (ok) {
            ok.hidden = false;
            ok.focus({ preventScroll: true });
          }
        })
        .catch(function () {
          if (btn) {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          }
          if (error) {
            error.hidden = false;
            error.focus({ preventScroll: true });
          }
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
